import UploadContentBlock from "./upload_content_block";
import male from "../../assets/images/male_face.png"
import female from "../../assets/images/female_face.png"

function UploadSection() {
    return (
        <>
            <div className={"float-left w-6/12 h-full flex flex-col px-48"}>
                <div className={"h-2/4 flex flex-col justify-center"}>
                    <p className={"text-6xl font-extrabold text-primary leading-tight"}>Detect <br/>DeepFakes</p>
                    <p className={"text-3xl font-light text-secondary leading-tight"}>100% Automated
                        and <span className={"font-bold text-primary"}>Free</span></p>
                </div>
                <div className={"h-2/4 relative"}>
                    <img src={female} alt="" className={"absolute bottom-0 right-0 h-4/6"}/>
                    <img src={male} alt="" className={"absolute bottom-0 left-0 h-8/12"}/>
                </div>
            </div>
            <div className={"float-right w-6/12 h-full flex justify-center items-center"}>
                <UploadContentBlock/>
            </div>
        </>
    );
}

export default UploadSection;

